import { useId, useState, type KeyboardEvent } from "react";
import { displaySkill } from "../lib/format";

/** Tag input: type a skill and press Enter or comma; Backspace on empty removes the last. */
export function SkillsInput({
  label,
  value,
  onChange,
  suggestions = [],
  placeholder = "Type a skill, then Enter",
}: {
  label: string;
  value: string[];
  onChange: (skills: string[]) => void;
  suggestions?: string[];
  placeholder?: string;
}) {
  const id = useId();
  const [draft, setDraft] = useState("");

  const add = (raw: string) => {
    const skill = raw.trim().toLowerCase().replace(/\s+/g, " ");
    if (skill && !value.includes(skill) && value.length < 30) onChange([...value, skill]);
    setDraft("");
  };

  const onKey = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      add(draft);
    } else if (e.key === "Backspace" && !draft && value.length) {
      onChange(value.slice(0, -1));
    }
  };

  return (
    <div className="field">
      <label className="label" htmlFor={id}>
        {label}
      </label>
      <div className="chips">
        {value.map((s) => (
          <span key={s} className="chip">
            {displaySkill(s)}
            <button type="button" aria-label={`Remove ${s}`} onClick={() => onChange(value.filter((x) => x !== s))}>
              ×
            </button>
          </span>
        ))}
        <input
          id={id}
          list={`${id}-list`}
          value={draft}
          placeholder={value.length ? "" : placeholder}
          onChange={(e) => (e.target.value.endsWith(",") ? add(e.target.value.slice(0, -1)) : setDraft(e.target.value))}
          onKeyDown={onKey}
          onBlur={() => draft && add(draft)}
        />
        <datalist id={`${id}-list`}>
          {suggestions.filter((s) => !value.includes(s)).map((s) => (
            <option key={s} value={s} />
          ))}
        </datalist>
      </div>
    </div>
  );
}
